var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{ref:"tooltip",attrs:{"data-trigger":_vm.trigger,"data-toggle":"tooltip","data-placement":_vm.placement,"title":_vm.title}},[_vm._t("default",[_c('i',{class:_vm.classes})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }